export default __webpack_public_path__ + "static/media/primary.2a90c7a39cb40bfc71eb8a5983198603.svg";